export default "__VITE_ASSET__B5o2tmqy__"